/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitoredCertificateDtoTimeToExpirationChronology
 */
export interface MonitoredCertificateDtoTimeToExpirationChronology {
    /**
     * 
     * @type {string}
     * @memberof MonitoredCertificateDtoTimeToExpirationChronology
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitoredCertificateDtoTimeToExpirationChronology
     */
    calendarType?: string;
}

export function MonitoredCertificateDtoTimeToExpirationChronologyFromJSON(json: any): MonitoredCertificateDtoTimeToExpirationChronology {
    return MonitoredCertificateDtoTimeToExpirationChronologyFromJSONTyped(json, false);
}

export function MonitoredCertificateDtoTimeToExpirationChronologyFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitoredCertificateDtoTimeToExpirationChronology {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'calendarType': !exists(json, 'calendarType') ? undefined : json['calendarType'],
    };
}

export function MonitoredCertificateDtoTimeToExpirationChronologyToJSON(value?: MonitoredCertificateDtoTimeToExpirationChronology | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'calendarType': value.calendarType,
    };
}

